import clsx from 'clsx';
import { getStatusStyle, getStatusValue } from '../../utils/statusHelpers';

interface OnboardingStatusBadgeProps {
  status: string;
}

function OnboardingStatusBadge({ status }: OnboardingStatusBadgeProps) {
  return (
    <div className={clsx('onboarding-status-badge', getStatusStyle(status))}>{getStatusValue(status)}</div>
  );
}

export default OnboardingStatusBadge;
